import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import Flickity from 'flickity';
import { OutfitCard } from './OutfitCard';
import styles from './OutfitSlider.module.scss';
export function OutfitSlider({ products, layout, title, description, ctaText, ctaLink = '#', useCollectionMetafieldHeading = false, collectionId, }) {
    var _a, _b;
    const carouselRef = useRef(null);
    const flickityInstanceRef = useRef(null);
    const hasItems = products.length > 0;
    const productKey = products.map((p) => p.id).join('-');
    useEffect(() => {
        if (!hasItems)
            return;
        let rafId = null;
        const initSlider = () => {
            if (!carouselRef.current)
                return;
            if (!carouselRef.current.offsetWidth) {
                rafId = requestAnimationFrame(initSlider);
                return;
            }
            if (flickityInstanceRef.current) {
                flickityInstanceRef.current.destroy();
                flickityInstanceRef.current = null;
            }
            flickityInstanceRef.current = new Flickity(carouselRef.current, {
                prevNextButtons: true,
                pageDots: false,
                wrapAround: false,
                contain: true,
                draggable: true,
                cellAlign: 'left',
                groupCells: false,
            });
            flickityInstanceRef.current.resize();
        };
        initSlider();
        const handleResize = () => { var _a; return (_a = flickityInstanceRef.current) === null || _a === void 0 ? void 0 : _a.resize(); };
        window.addEventListener('resize', handleResize);
        return () => {
            if (rafId !== null)
                cancelAnimationFrame(rafId);
            window.removeEventListener('resize', handleResize);
            if (flickityInstanceRef.current) {
                flickityInstanceRef.current.destroy();
                flickityInstanceRef.current = null;
            }
        };
    }, [hasItems, productKey]);
    if (!hasItems)
        return null;
    return (h("div", { class: styles.outfitSliderSection },
        useCollectionMetafieldHeading ? (h("div", { class: styles.outfitSliderTextBlock },
            h("div", { dangerouslySetInnerHTML: {
                    __html: typeof document !== 'undefined'
                        ? ((_b = (_a = document.getElementById(`plp-featured-outfits-header-${collectionId}`)) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : '')
                        : '',
                } }))) : (h("div", { class: styles.outfitSliderTextBlock },
            h("h3", { class: styles.outfitSliderTitle }, title),
            description && h("p", { class: styles.outfitSliderDescription }, description),
            ctaText && (h("a", { href: ctaLink, class: styles.outfitSliderButton }, ctaText)))),
        h("div", { class: styles.outfitSliderCarouselWrapper },
            h("div", { class: styles.outfitSliderCarousel, ref: carouselRef }, products.map((product) => (h("div", { class: styles.outfitSliderCell, key: `outfit-slider-${product.id}` },
                h(OutfitCard, { product: product, layout: layout, cardBackground: "#FFFFFF", cellBackground: "#F6F5F2" }))))))));
}
